import { gql, useQuery } from '@apollo/client';

export const GET_JOB_LOCATIONS_BY_DEPARTMENT = gql`
  query getJobLocationsByDepartment($departmentId: ObjectId!) {
    getJobLocationsByDepartment(departmentId: $departmentId) {
      job {
        _id
        title
        activityKey
        jobLocations {
          _id
          companyLocation {
            name
          }
        }
        questionnaireSettingsIds
      }
    }
  }
`;

export const useGetJobLocationsByDepartment = (departmentId?: string) => {
  const { data, loading } = useQuery(GET_JOB_LOCATIONS_BY_DEPARTMENT, {
    variables: {
      departmentId,
    },
    skip: !departmentId,
    fetchPolicy: 'network-only',
  });

  return { jobs: data?.getJobLocationsByDepartment || [], loading };
};
